/**
 * Header Component
 * Top header bar with ProductSwitcher and user info
 */

import ProductSwitcher from '@shared/components/ProductSwitcher';
import { useAuth } from '@shared/auth';
import { User, LogOut } from 'lucide-react';

const Header = () => {
  const { user, logoutUser } = useAuth();

  return (
    <div className="flex items-center space-x-4">
      <ProductSwitcher currentApp="analytics" />

      <div className="flex items-center space-x-3 text-sm text-gray-600">
        <div className="h-8 w-8 bg-primary-100 rounded-full flex items-center justify-center">
          <User size={16} className="text-primary-600" />
        </div>
        {user && (
          <span className="hidden sm:inline text-gray-700">
            {user.name || user.email}
          </span>
        )}
        <button
          onClick={logoutUser}
          className="p-1.5 rounded-md hover:bg-gray-100 text-gray-500 hover:text-gray-700"
          title="Sign out"
        >
          <LogOut size={16} />
        </button>
      </div>
    </div>
  );
};

export default Header;
